import React from 'react';
import treatment from '../../../assets/images/treatment.png'
import bgimg from '../../../assets/images/bg.png'


const Dentalcare = () => {
    return (
        <div className="hero mt-12" style={{ backgroundImage: `url(${bgimg})` }}>
            <div className="hero-content flex-col lg:flex-row">
                <img src={treatment} className="lg:w-1/3 rounded-lg shadow-2xl" />
                <div className='p-12'>
                    <h1 className="text-5xl font-bold">Exceptional Dental Care, on Your Terms</h1>
                    <p className="py-6">Provident cupiditate voluptatem et in. Quaerat fugiat ut assumenda excepturi exercitationem quasi. In deleniti eaque aut repudiandae et a id nisi.</p>
                    <button className="btn btn-primary bg-gradient-to-r from-primary to-secondary text-white">Get Started</button>
                </div>
            </div>
        </div>
    );
};

export default Dentalcare;